const SubAbasSetoresDaf = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/adm/setores/setor/${id}/dadosgerais`,
  },
];

export default SubAbasSetoresDaf;
